export default __webpack_public_path__ + "static/media/sari (3).7196cf6b.jpeg";